/**
 * Below are the colors and design tokens used throughout the app.
 * Unified design schema across Android, Web, and iOS with Android Material Design 3
 * as the primary version, providing high-contrast typography and accessible surfaces.
 */

import '@/global.css';
import { Platform } from 'react-native';

export * from './themes/types';
export * from './themes/base';
export * from './themes';

import { Colors } from './themes';

export type ThemeColor = keyof typeof Colors.light & keyof typeof Colors.dark;

export const Fonts = Platform.select({
  ios: {
    /** iOS `UIFontDescriptorSystemDesignDefault` with Inter priority */
    sans: 'Inter, system-ui, -apple-system',
    /** iOS `UIFontDescriptorSystemDesignSerif` */
    serif: 'ui-serif',
    /** iOS `UIFontDescriptorSystemDesignRounded` */
    rounded: 'ui-rounded',
    /** iOS `UIFontDescriptorSystemDesignMonospaced` */
    mono: 'ui-monospace',
  },
  default: {
    sans: 'Inter, normal',
    serif: 'serif',
    rounded: 'normal',
    mono: 'monospace',
  },
  web: {
    sans: "Inter, var(--font-display), -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    serif: 'var(--font-serif)',
    rounded: 'var(--font-rounded)',
    mono: 'var(--font-mono)',
  },
});

export const Spacing = {
  half: 2,
  one: 4,
  two: 8,
  three: 16,
  four: 24,
  five: 32,
  six: 64,
} as const;

export const BottomTabInset = Platform.select({ ios: 50, android: 80 }) ?? 0;
export const MaxContentWidth = 800;

/**
 * Card density layout specifications for standard and compact cards.
 * Enables consistent visual hierarchy and space maximization across entity cards.
 */
export const CardStyles = {
  standard: {
    padding: 12,
    borderRadius: 8,
    gap: 6,
    titleSize: 15,
  },
  compact: {
    padding: 8,
    borderRadius: 6,
    gap: 4,
    titleSize: 13,
  },
} as const;

